import { coreServiceUrl } from '../../../../config/environment';
import { callApi } from '../../../../utils/callApi';
import { ArticleDefinition } from '../../core-service.types';

export const getArticleFullDefinitionByIdApiCall = async (articleId: string) => {
  const url = `${coreServiceUrl}/wsc/articles/${articleId}/get-full-definition`;
  const { data } = await callApi<ArticleDefinition>(url);
  return data;
};
